import { jsonApi } from "./jsonApi";
import { DrupalFile } from "../shared/file";

export const getFile = (id: string) => jsonApi<DrupalFile>(`file/file/${id}`);
